import { Item } from '@epicuro-next/data/baskets-dto';
import { mapOrderType } from '@epicuro-next/data/baskets-grouping';
import { OrderType } from 'graphql-api/baskets-api-interfaces';
import { BasketItem } from 'graphql-api/gql-api-interfaces';

export const isBasketItemOfType =
  (orderType: OrderType) => (basketItem: BasketItem) => {
    return basketItem.orderType === orderType;
  };

export const isDtoBasketItemOfType =
  (orderType: OrderType) => (basketItem: Item) => {
    return mapOrderType(basketItem.orderType) === orderType;
  };

export const isNowBasketItem = isBasketItemOfType(OrderType.Now);
export const isFutureBasketItem = isBasketItemOfType(OrderType.Future);

export const isNowDtoBasketItem = isDtoBasketItemOfType(OrderType.Now);
export const isFutureDtoBasketItem = isDtoBasketItemOfType(OrderType.Future);
